import isEmpty from 'lodash/isEmpty';
import { fetchSiteFinancialStatus } from 'dashboard/actions/site-financial-status/site-financial-status.actions';
import { isChainHeadSelector, isStoreProfileSelector } from 'selectors';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { selectRetailer } from 'utils/rw-subordinates/actions/subordinate-list.actions';
import template from './financial-status-widget.html';

const mapStateToThis = ({ session, subordinateList, siteFinancialStatus, retailerDetails }) => {
  const { retailer } = session;
  const { data } = siteFinancialStatus;
  const isChainHead = isChainHeadSelector({ session });
  const isStoreProfile = isStoreProfileSelector({ session });
  const { selectedRetailer } = subordinateList;

  return {
    retailerDetails,
    isChainHead,
    isStoreProfile,
    selectedRetailer: isEmpty(selectedRetailer) ? retailerDetails : selectedRetailer,
    retailer,
    data,
  };
};

const mapDispatchToThis = {
  fetchSiteFinancialStatus,
  selectRetailer,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class FinancialStatusWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    if (retailerId) {
      await this.fetchSiteFinancialStatus(retailerId);
    }
  }

  $onDestroy() {
    this.selectRetailer({});
    this.unsubscribe();
  }
}

export default class FinancialStatusWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.template = template;
    this.controller = FinancialStatusWidgetController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/financial-status/financial-status-widget-component.js